import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't send the reset link — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-14 bg-[#FAF4F5]">
      <div className="w-full max-w-md bg-white border border-[#E8DCDD] rounded-sm p-8" data-testid="forgot-password-page">
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#8C4A57] mb-2">Password reset</div>
        <h1 className="font-serif text-3xl text-[#2D2628] mb-1">Forgot your password?</h1>
        {!sent ? (
          <>
            <p className="text-sm text-[#6B5E62] mb-6">
              Enter the email tied to your account and we'll send you a reset link.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-[10px] tracking-[0.2em] uppercase text-[#6B5E62]">Email</label>
                <input
                  type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-password-email"
                  className="w-full border border-[#E8DCDD] rounded-sm px-3 py-2 text-sm mt-1"
                />
              </div>
              <button
                type="submit" disabled={busy}
                data-testid="forgot-password-submit"
                className="w-full bg-[#8C4A57] text-white text-[12px] tracking-[0.14em] uppercase font-semibold py-3 rounded-sm hover:bg-[#6f3945] transition disabled:opacity-60"
              >
                {busy ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : "Send reset link"}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center py-4" data-testid="forgot-password-sent">
            <MailCheck className="w-12 h-12 text-[#8C4A57] mx-auto mb-4" />
            <p className="text-sm text-[#4A3E42] mb-2">
              If an account exists for <strong>{email}</strong>, a reset link is on its way.
            </p>
            <p className="text-xs text-[#6B5E62]">The link expires in 60 minutes and can only be used once.</p>
          </div>
        )}
        <p className="text-xs text-[#6B5E62] text-center mt-6">
          Remembered it? <Link to="/login" className="text-[#8C4A57] font-semibold">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
